import { createStyles, Title, Button, Group, Text, List, ThemeIcon, Anchor, Flex } from '@mantine/core';
import { IconCheck } from '@tabler/icons';
import { NetworkLogo } from './NetworkLogo';
import { LoginGoogleButton } from '../Components/LoginGoogleButton';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../store';


const useStyles = createStyles((theme) => ({
  inner: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,

    [theme.fn.smallerThan('md')]: {
      flexDirection: 'column',
      gap: theme.spacing.xl,
    },
  },

  centerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    padding: "10px 10px"
  },

  centerColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },

  smallTitle: {
    marginLeft: "10px",
    fontSize: "24px",
    fontWeight: "bold"
  },

  title: {
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: 44,
    lineHeight: 1.2,
    fontWeight: 900,

    [theme.fn.smallerThan('xs')]: {
      fontSize: 28,
    },
  },

  control: {
    [theme.fn.smallerThan('xs')]: {
      flex: 1,
    },
  },

  image: {
    flex: 1,

    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },

  highlight: {
    position: 'relative',
    backgroundColor: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).background,
    borderRadius: theme.radius.sm,
    padding: '4px 12px',
  },
}));

export function HeroBullets() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  let { user } = useStore();

  const loginCallback = (loginData: any) => {
    localStorage.setItem("token", loginData.token.toString());
    localStorage.setItem("refreshToken", loginData.refreshToken.toString());
    user.setData(loginData.user);
    navigate("/dashboard");
  };

  return (
    <>
      <div className={classes.inner} style={{justifyContent: "center"}}>
        <div>
          <Title className={classes.title}>
            A <span className={classes.highlight}>modern</span>
            api service for&nbsp;
            <Anchor href="https://tron.network/" target={"_blank"}>TRON</Anchor>,&nbsp;
          </Title>
          <Text color="dimmed" mt="md">
            Build fully functional accessible web applications faster than ever
          </Text>

          <br />
          <Title className={classes.title}>Advantages</Title>
          <List
            mt={30}
            spacing="sm"
            size="sm"
            icon={
              <ThemeIcon size={20} radius="xl">
                <IconCheck size={12} stroke={1.5} />
              </ThemeIcon>
            }
          >
            <List.Item>
              Real-Time Data Access
            </List.Item>
            <List.Item>
              Very fast, very robust
            </List.Item>
            <List.Item>
              Free, you can start using it without credit card
            </List.Item>
            <List.Item>
              100% secure, we do not save any information
            </List.Item>
          </List>

          <Group mt={30}>
            <Flex align={"center"}>
              <Button mr={10} component="a" href="/login" radius="xl" size="md" className={classes.control}>
                Get started
              </Button>
              <LoginGoogleButton loginCallback={loginCallback} />
            </Flex>
          </Group>
        </div>
        <div className={classes.centerColumn}>
          <div className={classes.centerRow}>
            <p>Supported networks (mainnet):</p>
          </div>
          <div className={classes.centerRow}>
            <NetworkLogo network="tron-mainnet" size={40} />
            <span className={classes.smallTitle}>Tron</span>
          </div>
          <div className={classes.centerRow}>
            <p>Supported networks (testnet):</p>
          </div>
          <div className={classes.centerRow}>
            <NetworkLogo network="tron-nile" size={40} />
            <span className={classes.smallTitle}>Tron(nile)</span>
          </div>
        </div>
      </div>
    </>
  );
}